<template>
  <div>
    <div class="column is-7 is-paddingless-left is-paddingless-top is-paddingless-bottom is-padding-right-xsmall">
      <r-label :label="'Caractéristique'" :sublabel="'(par exemple: sous-sol, extérieur, ...)'" :value="a.annex_type" :from-flux="fromFlux"></r-label>
      <div class="field has-addons">
        <div class="control w40 has-bg-light is-border columns is-vcentered is-padding-left-small">
          Parking
        </div>
        <div class="control is-expanded">
          <!-- <v-input :id="'annex_type' + a.index" :name="'annex_type' + a.index" @input="val => a.annex_type = val"
                  :model="a.annex_type | parkingTypeLabel"
                  :errors-bag="errors" data-vv-value-path="val"
                  data-vv-as="Type">
          </v-input> -->
          <multiselect v-model="a.annex_type"
                      class="no-caret"
                      tag-placeholder="Ajouter ce nouveau type"
                      :placeholder="''"
                      :options="parkingType"
                      :multiple="false"
                      :taggable="true"
                      :show-labels="false"
                      :searchable="true"
                      @tag="addTag">
            <span slot="noOptions">La liste est vide</span>
            <template slot="singleLabel" slot-scope="props">
              <span class="tag is-primary is-radius-xlarge">
                {{ props.option }}
                <a class="is-margin-left-small has-text-white" @click="a.annex_type = null"><i class="fas fa-times-circle"></i></a>
              </span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>
    <div class="column is-5 is-paddingless-right is-paddingless-left is-paddingless-top is-paddingless-bottom">
      <label class="label" for="remuneration">Détails / Informations / N° <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
      <div class="field has-addons">
        <div class="control is-expanded">
          <v-input :id="'annex_info' + a.index" :name="'annex_info' + a.index" @input="val => a.info = val"
                  :model="a.info"
                  :errors-bag="errors" data-vv-value-path="val"
                  data-vv-as="Infos">
          </v-input>
        </div>
        <div class="control">
          <a @click="remove(a.index)" class="button is-square is-grey is-inverted is-border">
            <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
          </a>
        </div>
      </div>
    </div>
    <div style="display: none;">
      <div class="field">
        <div class="control">
          <v-input :id="'annex_is_parking' + a.index" :name="'annex_is_parking' + a.index" @input="val => a.is_parking = val"
                  :model="a.is_parking"
                  :errors-bag="errors" data-vv-value-path="val"
                  data-vv-as="Infos">
          </v-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '../../mixins'

  export default {
    name: 'AnnexeItem',
    mixins: [DefaultValues],
    data () {
      return {
        annexesType: []
      }
    },
    props: {
      source: {
        type: Object,
        required: true,
        default: () => {}
      },
      fromFlux: Boolean,
      defaultParkingType: {
        type: Array
      }
    },
    computed: {
      a () {
        return this.source
      },
      parkingType () {
        return this.defaultParkingType
      }
    },
    methods: {
      remove () {
        this.$emit('remove', this.a.index)
      },
      addTag (val) {
        this.$emit('updateAnnexType', val)
        this.a.annex_type = val
      }
    }
  }
</script>

<style scoped>
.icon.is-small {
  height: .1rem;
}
</style>

<style>
.multiselect.no-caret .multiselect__select:before {
  content: ''
}
</style>




// WEBPACK FOOTER //
// src/components/lot/ParkingItem.vue